var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"24","height":"24","key":0}),React.createElement("path",{"fill":"#17304D","fillRule":"nonzero","d":"M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 Z","key":1}),React.createElement("path",{"fill":"#17304D","fillRule":"nonzero","d":"M11.5 11L11.5 17C11.5 17.2761424 11.7238576 17.5 12 17.5 12.2761424 17.5 12.5 17.2761424 12.5 17L12.5 11C12.5 10.7238576 12.2761424 10.5 12 10.5 11.7238576 10.5 11.5 10.7238576 11.5 11zM11.5 8L11.5 9C11.5 9.27614237 11.7238576 9.5 12 9.5 12.2761424 9.5 12.5 9.27614237 12.5 9L12.5 8C12.5 7.72385763 12.2761424 7.5 12 7.5 11.7238576 7.5 11.5 7.72385763 11.5 8z","key":2})]));
}

Info.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Info;

Info.default = Info;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/info.svg
// module id = 811
// module chunks = 0